var b = Object.defineProperty;
var A = (n, e, t) => e in n ? b(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var l = (n, e, t) => A(n, typeof e != "symbol" ? e + "" : e, t);
import { useMemo as _, useEffect as y, useRef as C, useState as S } from "react";
import { atom as i, useSetAtom as u, useAtomValue as w, useAtom as I } from "jotai";
import { atomWithStorage as R } from "jotai/utils";
import { differenceInSeconds as M, format as Z } from "date-fns";
import { RudderAnalytics as x } from "@rudderstack/analytics-js";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import D from "react-draggable";
function m() {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}
const f = i([]), k = i([]), d = i([]), H = i(
  null,
  (n, e, t) => {
    const r = {
      ...t,
      id: m(),
      receivedAt: /* @__PURE__ */ new Date()
    };
    e(d, (c) => [
      ...c.slice(-49),
      // Only keep 50 events.
      { ...r, id: m(), receivedAt: /* @__PURE__ */ new Date() }
    ]);
    for (const c of n(f))
      c.appendEvent(r);
  }
), $ = i(null, (n, e) => {
  e(d, []);
}), O = i(null, (n, e, t) => {
  e(f, (r) => r.find(({ handle: c }) => c === t.handle) ? r : (t.load({
    bufferedEvents: n(d),
    onConnected: () => e(k, (c) => [
      ...c,
      t.handle
    ])
  }), [...r, t]));
});
function T(n) {
  const { type: e, args: t } = n;
  return JSON.stringify({ type: e, args: t });
}
const j = i((n) => {
  const t = n(d).map((r) => ({
    ...r,
    hash: T(r)
  }));
  return t.map(({ hash: r, ...c }, s) => {
    const N = t.slice(0, s).filter(
      ({ receivedAt: h }) => 3 > M(c.receivedAt, h)
    ).filter(
      (h) => h.hash === r
    );
    return {
      ...c,
      ...0 < N.length ? { isDuplicate: !0 } : {}
    };
  });
}), B = R(
  "react-tracker-helper-enabled",
  !1,
  void 0,
  { getOnInit: !0 }
), J = i((n) => {
  n(k);
  const e = n(f);
  return {
    events: n(j),
    adapters: e.map((r) => ({
      name: r.name,
      isConnected: r.isConnected
    }))
  };
});
function re() {
  const n = u(O), e = u(H);
  return _(
    () => ({
      loadAdapter: n,
      identify: (...t) => e({
        type: "identify",
        args: t
      }),
      page: (...t) => e({ type: "page", args: t }),
      track: (...t) => e({ type: "track", args: t }),
      group: (...t) => e({ type: "group", args: t }),
      alias: (...t) => e({ type: "alias", args: t }),
      reset: (...t) => e({ type: "reset", args: t })
    }),
    [n, e]
  );
}
function P() {
  const n = u($);
  return {
    ...w(J),
    clearEvents: n
  };
}
class g {
  /**
   * Construct an adapter with the given name and handle.
   */
  constructor({ name: e, handle: t }) {
    /**
     * Human readable name for adapter.
     */
    l(this, "name");
    /**
     * Uniqud handle for this adapter instance.
     */
    l(this, "handle");
    /**
     * Is the SDK managed by this adapter ready to receive events?
     */
    l(this, "isConnected", !1);
    /**
     * Callback for when this adapter is connected.
     */
    l(this, "onConnected");
    /**
     * Array of buffered events.
     */
    l(this, "bufferedEvents", []);
    this.name = e, this.handle = t;
  }
  /**
   * Called by the adapter when the SDK is ready to receive events.
   */
  connect() {
    this.isConnected = !0, this.onConnected && this.onConnected(), this._emitBufferedEvents();
  }
  /**
   * Load the adapter with the given buffered events.
   * These events will be emitted when the adapter is connected.
   */
  load({
    onConnected: e,
    bufferedEvents: t
  }) {
    this.onConnected = e, this.bufferedEvents = t;
  }
  /**
   * Append a new event for emit.
   *
   * - If the adapter is connected, send it to the onEvent handler.
   * - Otherwise, append it to the buffered events array for future emit.
   */
  appendEvent(e) {
    this.isConnected ? this.onEvent(e) : this.bufferedEvents.push(e);
  }
  /**
   * Sort and emit buffered events.
   */
  _emitBufferedEvents() {
    this.bufferedEvents.length !== 0 && (this.bufferedEvents.sort(
      (e, t) => v.indexOf(e.type) - v.indexOf(t.type)
    ), this.bufferedEvents.forEach((e) => this.onEvent(e)), this.bufferedEvents = []);
  }
}
const v = [
  "identify",
  "page",
  "track",
  "group",
  "alias",
  "reset"
];
class ae extends g {
  /**
   * Load the Klaviyo plugin.
   */
  constructor({ companyId: t }) {
    super({ name: "Klaviyo", handle: "klaviyo" });
    /**
     * Company ID associated with the Klaviyo script.
     */
    l(this, "companyId");
    this.companyId = t, this._appendScript(), this._pollForScriptReady();
  }
  /**
   * Append Klaviyo tracking script to the head.
   */
  _appendScript() {
    const t = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${this.companyId}`;
    if (document.querySelector(`script[src="${t}"]`)) return;
    const r = document.createElement("script");
    r.src = t, r.async = !0, document.head.appendChild(r);
  }
  /**
   * Poll the window every 1 second until the Klaviyo SDK is ready.
   */
  _pollForScriptReady() {
    const t = setInterval(() => {
      typeof window < "u" && typeof window.klaviyo < "u" && (this.connect(), clearInterval(t));
    }, 1e3);
  }
  /**
   * Emit the given event to Klaviyo.
   */
  async onEvent(t) {
    const r = window.klaviyo;
    if (r && t.type === "identify") {
      const c = this._klaviyoIdentifyPayload(t);
      c && r.identify(c);
    }
  }
  /**
   * Resolve a Klaviyo identify payload.
   *
   * @see https://developers.klaviyo.com/en/v1-2/docs/identify-api-reference
   */
  _klaviyoIdentifyPayload(t) {
    const r = t.args[1];
    if (!r || typeof r != "object") return;
    const c = {
      ...r.email ? { $email: r.email } : {},
      ...r.firstName ? { $first_name: r.firstName } : {},
      ...r.lastName ? { $last_name: r.lastName } : {}
    };
    if (q(c))
      return c;
  }
}
function q(n) {
  for (let e in n)
    if (n[e]) return !0;
  return !1;
}
const p = new x();
class ce extends g {
  /**
   * Load the RudderStack plugin.
   */
  constructor({
    writeKey: e,
    loadOptions: t,
    dataPlaneUrl: r
  }) {
    super({ name: "RudderStack", handle: `rudderstack-${e}` }), p.ready(() => this.connect()), p.load(e, r, t);
  }
  /**
   * Emit the given event to RudderStack.
   */
  async onEvent(e) {
    p[e.type](...e.args);
  }
}
function se({
  enabled: n,
  onClose: e
} = {}) {
  const [t, r] = I(B);
  y(() => {
    new URL(window.location.href).searchParams.has("enableTrackerHelper") && r(!0);
  }, [n, r]);
  function c() {
    e && e(), r(!1);
  }
  return (typeof n < "u" ? n : t) ? /* @__PURE__ */ a(F, { onClose: c }) : null;
}
function F({ onClose: n }) {
  const { events: e, adapters: t, clearEvents: r } = P(), c = C(null);
  return y(() => {
    const s = c.current;
    s && s.scrollTo({ top: s.scrollHeight });
  }, [e]), /* @__PURE__ */ a(D, { handle: ".tracker-helper__drag-handle", children: /* @__PURE__ */ o("div", { className: "tracker-helper", children: [
    /* @__PURE__ */ o("div", { className: "tracker-helper__header", children: [
      /* @__PURE__ */ a(V, {}),
      /* @__PURE__ */ a("span", { className: "tracker-helper__title", children: "Tracker helper" }),
      /* @__PURE__ */ a(W, { onClose: n })
    ] }),
    /* @__PURE__ */ o("div", { className: "tracker-helper__content", ref: c, children: [
      t.map((s) => /* @__PURE__ */ o("div", { className: "tracker-helper__connection", children: [
        /* @__PURE__ */ a("span", { className: "tracker-helper__title", children: s.name }),
        s.isConnected ? /* @__PURE__ */ a("div", { className: "tracker-helper__badge tracker-helper__badge--success", children: "Connected" }) : /* @__PURE__ */ a("div", { className: "tracker-helper__badge", children: "Disconnected" })
      ] }, s.name)),
      /* @__PURE__ */ o("div", { className: "tracker-helper__summary", children: [
        /* @__PURE__ */ o("div", { children: [
          /* @__PURE__ */ a("span", { className: "tracker-helper__title", children: "Events received" }),
          /* @__PURE__ */ a("div", { className: "tracker-helper__badge tracker-helper__badge--no-dot", children: e.length })
        ] }),
        0 < e.length && /* @__PURE__ */ a("button", { onClick: () => r(), children: "Clear events" })
      ] }),
      0 < e.length && /* @__PURE__ */ a("div", { className: "tracker-helper__events", children: e.map((s) => /* @__PURE__ */ a(K, { event: s }, s.id)) })
    ] })
  ] }) });
}
function K({ event: n }) {
  const [e, t] = S(!1);
  return /* @__PURE__ */ o("div", { className: "tracker-helper__event", children: [
    /* @__PURE__ */ o(
      "button",
      {
        onClick: () => t((r) => !r),
        className: "tracker-helper__event-button tracker-helper__event-button--emitted",
        children: [
          /* @__PURE__ */ a("span", { className: "tracker-helper__event-type", children: n.type }),
          /* @__PURE__ */ a("span", { className: "tracker-helper__event-args", children: `${n.args[0]}` }),
          /* @__PURE__ */ a("span", { className: "tracker-helper__event-time", children: Z(n.receivedAt, "HH:mm:ss") }),
          n.isDuplicate && /* @__PURE__ */ o("span", { className: "tracker-helper__warning", children: [
            /* @__PURE__ */ a(L, {}),
            "Duplicate"
          ] })
        ]
      }
    ),
    e && /* @__PURE__ */ a(U, { event: n })
  ] });
}
function U({ event: n }) {
  const e = _(() => JSON.stringify(n.args, null, 2), [n]);
  return /* @__PURE__ */ a("div", { className: "tracker-helper__event-json", children: /* @__PURE__ */ a("pre", { children: e }) });
}
function V() {
  return /* @__PURE__ */ o(
    "svg",
    {
      viewBox: "1 1 18 18",
      fill: "currentColor",
      className: "tracker-helper__drag-handle",
      children: [
        /* @__PURE__ */ a("path", { d: "M7.5 4.5c-.552 0-1 .448-1 1v.5c0 .552.448 1 1 1h.5c.552 0 1-.448 1-1v-.5c0-.552-.448-1-1-1h-.5Z" }),
        /* @__PURE__ */ a("path", { d: "M7.5 8.75c-.552 0-1 .448-1 1v.5c0 .552.448 1 1 1h.5c.552 0 1-.448 1-1v-.5c0-.552-.448-1-1-1h-.5Z" }),
        /* @__PURE__ */ a("path", { d: "M6.5 14c0-.552.448-1 1-1h.5c.552 0 1 .448 1 1v.5c0 .552-.448 1-1 1h-.5c-.552 0-1-.448-1-1v-.5Z" }),
        /* @__PURE__ */ a("path", { d: "M12 4.5c-.552 0-1 .448-1 1v.5c0 .552.448 1 1 1h.5c.552 0 1-.448 1-1v-.5c0-.552-.448-1-1-1h-.5Z" }),
        /* @__PURE__ */ a("path", { d: "M11 9.75c0-.552.448-1 1-1h.5c.552 0 1 .448 1 1v.5c0 .552-.448 1-1 1h-.5c-.552 0-1-.448-1-1v-.5Z" }),
        /* @__PURE__ */ a("path", { d: "M12 13c-.552 0-1 .448-1 1v.5c0 .552.448 1 1 1h.5c.552 0 1-.448 1-1v-.5c0-.552-.448-1-1-1h-.5Z" })
      ]
    }
  );
}
function W({ onClose: n }) {
  return /* @__PURE__ */ a("button", { className: "tracker-helper__close-btn", onClick: () => n(), children: /* @__PURE__ */ a("svg", { viewBox: "0 0 20 20", fill: "currentColor", children: /* @__PURE__ */ a("path", { d: "M13.97 15.03a.75.75 0 1 0 1.06-1.06l-3.97-3.97 3.97-3.97a.75.75 0 0 0-1.06-1.06l-3.97 3.97-3.97-3.97a.75.75 0 0 0-1.06 1.06l3.97 3.97-3.97 3.97a.75.75 0 1 0 1.06 1.06l3.97-3.97 3.97 3.97Z" }) }) });
}
function L() {
  return /* @__PURE__ */ o("svg", { viewBox: "0 0 20 20", fill: "currentColor", children: [
    /* @__PURE__ */ a("path", { d: "M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z" }),
    /* @__PURE__ */ a("path", { d: "M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
    /* @__PURE__ */ a(
      "path",
      {
        fillRule: "evenodd",
        d: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      }
    )
  ] });
}
export {
  ae as KlaviyoAdapter,
  ce as RudderStackAdapter,
  se as TrackerHelper,
  F as TrackerHelperInner,
  f as adaptersAtom,
  H as appendEventAtom,
  $ as clearEventsAtom,
  k as connectedAdaptersAtom,
  j as debugEventsAtom,
  d as eventsAtom,
  B as helperEnabledAtom,
  O as loadAdapterAtom,
  J as trackerStateAtom,
  re as useTracker,
  P as useTrackerState
};
